import React, { useState, useEffect, useContext, useRef } from "react";
import restService from "../../../../../restService";
import { addDays } from "date-fns";
import UserContext from "../../../../../contexts/UserContext";
import CampaignContext from "../../../../../contexts/CampaignContext";
import { Modal, Tooltip } from "flowbite-react";
import Warning from "../../../../../assets/images/warning.svg";
import Confetti from "react-confetti";
import { DatePicker } from "../../../../components";
import c_question from "../../../../../assets/icons/c-question.svg";
import { PulseLoader } from "react-spinners";
import MultiSelect from "../../../../components/MultiSelect";
import { Switch } from "@headlessui/react";

const RunDraw = ({
  setIsRunDraw,
  open,
  setOpen,
  onClose,
  success,
  setSuccess,
  loading,
}) => {
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);

  const Ref = useRef();

  const [width, setWidth] = useState();
  const [height, setHeight] = useState();

  const [isRewarding, setIsRewarding] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [drawWinners, setDrawWinners] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);

  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [drawData, setDrawData] = useState({
    numberOfWinners: "",
    drawType: "",
    startDate: "",
    endDate: "",
    testRun: false,
    // chance: false,
  });

  const handleChange = (e) => {
    setDrawData({ ...drawData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setDrawData({
      ...drawData,
      startDate: new Date(state[0].startDate).toISOString(),
      endDate: new Date(state[0].endDate).toISOString(),
    });
  }, [state]);

  const getListSize = () => {
    const newWidth = Ref?.current?.clientWidth;
    setWidth(newWidth);

    const newHeight = Ref?.current?.clientHeight;
    setHeight(newHeight);
  };

  useEffect(() => {
    getListSize();
  }, [drawWinners]);

  useEffect(() => {
    window.addEventListener("resize", getListSize);
    // console.log("width", width);

    return () => {
      window.removeEventListener("resize", getListSize);
    };
  }, []);

  const handleRunDraw = async () => {
    // setLoading(true);
    setIsRewarding(true);
    try {
      const {
        data: { data },
      } = await restService.Entries.runDraw(
        campaign.id,
        { ...drawData, regions: selectedRegions },
        user.accessToken
      );

      setDrawWinners(data);
    } catch (error) {
      console.log(error);
    } finally {
      // setLoading(false);
      setIsRewarding(false);
    }
  };

  const regions = [
    "Bono",
    "Ashanti",
    "Western-North",
    "Northern",
    "Greater Accra",
    "Central",
    "Savannah",
    "Upper East",
    "Upper West",
    "Volta",
    "Bono-East",
    "Western",
    "Eastern",
    "North-East",
    "Ahafo",
    "Oti",
  ];

  const [selectionType, setSelectionType] = useState(null);

  return (
    <>
      <div className="flex item center md:mb-0 justify-end cursor-pointer mb-4">
        <div className=" flex items-center gap-4">
          <p>Trial run</p>
          <Switch
            checked={drawData.testRun}
            onChange={() => {
              setDrawData({ ...drawData, testRun: !drawData.testRun });
            }}
            className={`${drawData.testRun ? "bg-green-400" : "bg-gray-200"}
          relative inline-flex h-[25px] w-[50px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
          >
            <span className="sr-only">Trial run</span>
            <span
              aria-hidden="true"
              className={`${
                drawData.testRun ? "translate-x-7" : "translate-x-0"
              }
            pointer-events-none inline-block h-[23px] w-[23px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
            />
          </Switch>
        </div>
      </div>
      <div className="flex">
        <div className="flex flex-col gap-2">
          <label htmlFor="endDate" className="text-[#24211D] text-sm">
            Start & End Date
          </label>
          <div className="md:w-[250px] border  rounded items-center flex justify-center py-[2px] bg-[#F4F4F4]  w-full border-[#E6E6E6]">
            <DatePicker state={state} setState={setState} />
          </div>
        </div>
      </div>
      <form className="flex flex-col gap-6">
        <div className="flex md:flex-row flex-col md:items-center gap-3 md:gap-9"></div>

        {/* Draw type */}
        <div className="flex flex-col gap-2">
          <div className=" flex items-center gap-2">
            <label htmlFor="drawType" className="text-sm text-[#24211D]">
              Selection type
            </label>
          </div>
          <div className="flex md:flex-row flex-col md:items-center gap-2 md:gap-[1.6rem]">
            <select
              required
              onChange={(e) => {
                setDrawData({
                  ...drawData,
                  drawType: e.target.value,
                });

                const value = e.target.value;
                if (value === "ENTRIES") {
                  setSelectionType("Consumers with highest entries");
                  return;
                }
                if (value === "WINS") {
                  setSelectionType("Consumers with highest wins");
                  return;
                }
                if (value === "UNIQUE") {
                  setSelectionType("Unique Entries");
                  return;
                }

                setSelectionType("Custom Draw Selection Criteria");
              }}
              name="drawType"
              id="drawType"
              className="text-sm rounded invalid:text-[#848484] bg-[#F4F4F4] md:w-[250.67px] w-full border-[#E6E6E6]"
            >
              <option value="" selected disabled hidden>
                Select option
              </option>
              <option value="ENTRIES">Consumers with highest entries</option>
              <option value="WINS">Consumers with highest wins</option>
              <option value="UNIQUE">Unique Entries</option>
              <option value="CUSTOM">Custom Draw Selection Criteria</option>
            </select>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-sm">Specify the parameters of the draw</p>
          <hr />
          <div className="flex flex-col gap-2">
            <div className=" flex items-center gap-2">
              <label htmlFor="" className="text-sm text-[#24211D]">
                Region(optional)
              </label>
            </div>

            <div className="flex flex-col gap-1">
              <MultiSelect
                options={regions}
                selectedOptions={selectedRegions}
                setSelectedOptions={setSelectedRegions}
                title=" Choose Region(s)"
                containerClass={"md:w-[250.67px] w-full"}
              />

              {selectedRegions.length > 0 && (
                <p className="text-sm">Total: {selectedRegions.length}</p>
              )}
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <div className=" flex items-center gap-2">
              <label
                htmlFor="numberOfWinners"
                className="text-sm text-[#24211D]"
              >
                Number of winners
              </label>
            </div>
            <div className="flex md:flex-row flex-col md:items-center gap-2 md:gap-[1.6rem]">
              <input
                type="number"
                placeholder="20"
                name="numberOfWinners"
                id="numberOfWinners"
                className="rounded placeholder:opacity-50 md:w-[250.67px] w-full"
                onChange={(e) => {
                  setDrawData({
                    ...drawData,
                    numberOfWinners: e.target.value,
                  });
                }}
              />
            </div>
          </div>
        </div>

        {/* submit */}
        <div className="flex gap-3">
          <button
            disabled={
              drawData.startDate === "" ||
              drawData.drawType === "" ||
              drawData.numberOfWinners === ""
            }
            onClick={(e) => {
              e.preventDefault();
              // setIsRunDraw(true);
              setSuccess(false);
              setOpen(true);
              handleRunDraw();
            }}
            className="text-white disabled:bg-[#ccc] w-full md:w-auto bg-[#3989DD] text-base my-6 py-3 px-6 transition hover:bg-[#235080] rounded"
          >
            Select winners
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              setIsRunDraw(false);
            }}
            className="border rounded  px-6 md:text-sm text-base my-6 py-3 hover:bg-[#c700001a] hover:text-red-600"
          >
            Cancel
          </button>
        </div>
      </form>

      <Modal show={open} size="3xl" placement="center" onClose={onClose}>
        <div ref={Ref} className="h-[70vh]">
          {/* Invite member */}
          {isRewarding ? (
            <div className="md:p-12 p-5 flex justify-center flex-col items-center">
              <h4 className=" text-[24px] font-[700] text-[#24211D]">
                Please wait...
              </h4>
              <p className=" text-[14px] text-[#b4b4b4]">Selecting winner(s)</p>

              <div className=" flex md:flex-row  items-center gap-1 md:gap-3 mt-1">
                <PulseLoader color="#FF6A3A" />
              </div>
            </div>
          ) : (
            // success

            <>
              <div className="md:py-10 h-[57vh]  md:px-10 p-5 mx-auto flex  flex-col items-center">
                {drawWinners.length < 1 ? (
                  <h4 className=" text-[22px] text-center font-[700] text-[#24211D] uppercase">
                    Top {drawData.numberOfWinners} Consumer(s) selected Based On
                    Selection Type{" "}
                    <span className="text-base text-center">
                      ({selectionType})
                    </span>
                    {/* {drawData.drawType.toLocaleLowerCase()} */}
                  </h4>
                ) : (
                  <h4 className=" text-[22px] text-center font-[700] text-[#24211D] uppercase">
                    Top {drawData.numberOfWinners} Consumer(s) selected Based On
                    Selection Type{" "}
                    <span className="text-base text-center">
                      ({selectionType})
                    </span>
                  </h4>
                )}

                {drawWinners && drawWinners.length > 0 ? (
                  <div className="w-full overflow-auto max-h-[350px]">
                    <div className=" flex md:flex-row  items-center gap-1 md:gap-3 mt-1">
                      <Confetti width={width} height={height} />
                    </div>
                    <div
                      // ref={ref}

                      className="flex flex-wrap gap-4 justify-center align-center w-full mt-3 overflow-y-scroll"
                    >
                      {drawWinners.map((winner, index) => (
                        <div key={index}>
                          <p className="text-base bg-[#e7e7e7] px-3 py-2 rounded">
                            {winner.msisdn}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="flex h-[37vh]  mt-3 text-[#b4b4b4] items-center justify-center">
                      <p>No Winner Found.</p>
                    </div>
                  </>
                )}
              </div>

              <div className=" flex md:flex-row gap-4 justify-center  items-center md:gap-3 mb-3">
                <button
                  className=" border rounded py-2 mb-10 md:text-base text-xs px-7 hover:bg-[#00C74C] transition hover:text-white bg-[#00C74C1a] text-[#00C74C]"
                  onClick={() => {
                    setDrawData({
                      numberOfWinners: "",
                      drawType: "",
                      startDate: "",
                      endDate: "",
                    });

                    setSelectedRegions([]);
                    setSelectionType(null);
                    onClose();
                  }}
                >
                  Try Again
                </button>
                <button
                  className=" border rounded py-2 mb-10 md:text-base text-xs px-7 hover:bg-[#ff0000] transition hover:text-white bg-[#c700001a] text-red-600"
                  onClick={() => {
                    setIsRunDraw(false);
                    setDrawData({
                      numberOfWinners: "",
                      drawType: "",
                      startDate: "",
                      endDate: "",
                    });

                    setSelectedRegions([]);
                    setSelectionType(null);
                    onClose();
                  }}
                >
                  Close
                </button>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default RunDraw;
